export const ipcSend = (chanelName, ...arg) => {
  if (!window.ipcRenderer) {
    return
  }
  console.log('[IPC SEND]: ', chanelName, ...arg)
  window.ipcRenderer.send(chanelName, ...arg)
}

export const ipcSendCocoFaxAction = (actionName, params) => {
  const chanelName = 'cocofax_action'
  ipcSend(chanelName, actionName, params)
}
